import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";

const initialState = {
    hisps: [],
    hispsLogo: {},
    allHispsLoading: false,
    allHispsError: false,
    allHispsErrorMessage: null,
}


export const getAllHisps = createAsyncThunk(
    "allHisps/getAllHisps",
    async (_, { rejectWithValue }) => {
        return await fetch (ApiUrl.Hisps.query.getPath('', 0))
            .then(handleHttpResponse)
            .catch( err => {
                if (err) {
                    return rejectWithValue("Failed to get all hisps");
                }
            })
    }
)

export const allHispsSlice = createSlice({
    name: 'allHisps',
    initialState,
    reducers:{
        closeAllHispsErrorSnackbar: (state, action) => {
            state.allHispsError = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllHisps.pending, (state, action) => {
                state.allHispsLoading = true;
            })
            .addCase(getAllHisps.fulfilled, (state, action) => {
                const content = action.payload.content;
                state.hisps = content;

                content.map( c => state.hispsLogo[c.hispId] = c.logoUrl);

                state.allHispsLoading = false;

            })
            .addCase(getAllHisps.rejected, (state, action) => {
                state.allHispsLoading = false;
                if (action.payload) {
                    state.allHispsErrorMessage = action.payload;
                    state.allHispsError = true;
                }

            })
    }
})

export const { closeAllHispsErrorSnackbar } = allHispsSlice.actions;
export default allHispsSlice.reducer;

